import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import DocumentTitle from 'react-document-title'

import style from './careers.sass'

class Careers extends Component {
  render() {
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Careers'/>
        <div styleName='banner'>
          <h3>Challenge Yourself, Build the Future</h3>
        </div>
        <section className='bg-white' styleName='description'>
          <div className='landing-container'>
            <p>
              Backed by Y Combinator and leading VCs in capital markets, we are a team of highly driven
              individuals who love to challenge ourselves and make big things happen. We have strong background
              in Quantitative Trading with years of experience at several prominent wall street firms. We are
              proud of our individual achievements, as well as what we are capable of as a team.
            </p>
            <p>
              Our team is building the next generation of trading technologies, and with wall street moving
              faster than ever towards Algorithmic Trading, Algoriz will play a critical role in bridging the
              gap between technology and traders.
            </p>
          </div>
        </section>
        <section styleName='positions'>
          <div className='landing-container'>
            <h2>Available Positions</h2>
            <ul>
              <li>
                <Link to='careers/front-end-software-engineer'>
                  <h3>Software Engineer</h3>
                  <p>Front End</p>
                </Link>
              </li>
              <li>
                <Link to='careers/full-stack-software-engineer'>
                  <h3>Software Engineer</h3>
                  <p>Full Stack</p>
                </Link>
              </li>
              <li>
                <Link to='careers/digital-marketing-manager'>
                  <h3>Digital Marketing Manager</h3>
                </Link>
              </li>
            </ul>
          </div>
        </section>
        <section className='bg-white'>
          <div className='landing-container' styleName='contact'>
            <h2>Don’t see the job for you?</h2>
            <p>
              We are always looking for passionate and driven individuals eager to challenge themselves.
              If you think we can work together, but you don&apos;t see a position that matches your interests
              and background, reach u at
            </p>
            <a href="mailto:info@algoriz.com">info@algoriz.com</a>
          </div>
        </section>
      </div>
    )
  }
}

export default Careers
